import React from 'react'
import { createPortal } from 'react-dom'

import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'
import { Lightbox } from 'react-modal-image'
import useViewModel from './ViewModel'

const PileExecutionAttachmentView: React.FC = () => {
  const {
    modalsRoot,
    open,
    pileHole1,
    pileHole2,
    onClose,
    data,
    onSubmit,
    onRemove,
    lightBoxImage,
    lightBoxAlt,
    openImage,
    closeImage,
    openLightBox,
  } = useViewModel()

  return createPortal(
    <Modal
      id='kt_modal_project_pile_execution_attachment'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-dialog-scrollable mw-900px'
      show={open}
      onHide={onClose}
      backdrop={true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>แนบรูปภาพรอยเชื่อมของเสา</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={onClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div className='modal-body'>
          <div className='alert alert-primary p-5 mb-10'>
            <div>
              <span className='d-inline-block fw-bold me-4'>เสาที่ 1: </span>
              <span className='d-inline-block'>
                {pileHole1?.pileTitle} - {pileHole1?.pileCode}
              </span>
            </div>

            <div>
              <span className='d-inline-block fw-bold me-4'>เสาที่ 2: </span>
              <span className='d-inline-block'>
                {pileHole2?.pileTitle} - {pileHole2?.pileCode}
              </span>
            </div>
          </div>

          <div
            className='border-dashed w-100 h-150px bg-hover-light transition-500'
            onClick={() => {
              document.getElementById('pile-exection-attachment-input')?.click()
            }}>
            <div className='d-flex flex-column align-items-center justify-content-center h-100 cursor-pointer'>
              <KTSVG
                className='svg-icon-5x svg-icon-primary'
                path='/media/icons/duotune/general/gen006.svg'
              />

              <p className='text-gray-500 fw-bold fs-3 mb-5 mt-5'>Browse Files</p>
              <p className='text-gray-400'>Supports: PNG, JPEG, JPG</p>

              <input
                id='pile-exection-attachment-input'
                type='file'
                className='d-none'
                multiple
                onChange={(e: any) => {
                  onSubmit(e.target.files?.[0])

                  // @ts-ignore
                  e.target.value = null
                }}
              />
            </div>
          </div>

          {data.map((image, idx) => (
            <div
              key={`image-${idx}`}
              className='d-flex flex-row justify-content-between align-items-center p-5 bg-grey border rounded-2 my-5 shadow-sm'>
              <div className='d-flex flex-row ' style={{ columnGap: '12px' }}>
                <div className='w-200px text-center'>
                  <img
                    src={image.url}
                    alt={`${pileHole1?.pileTitle} - ${pileHole2?.pileTitle} - ${idx}`}
                    onError={(e: any) => {
                      e.currentTarget.src = '/media/icons/default-placeholder.png'

                      e.currentTarget.onerror = null
                    }}
                    className='h-100px rounded shadow-sm'
                  />
                </div>
                {/* <input
                  className='form-control form-control-sm mt-2 h-20px w-300px'
                  placeholder='ระบุหมายเหตุ'
                  value={image.description}
                  onChange={(e:any) => onChangeNote(idx, e.target.value)}
                /> */}
              </div>

              <div>
                {/* <button
                  className={clsx('btn btn-sm btn-icon me-5', {
                    'btn-light-primary btn-active-primary': image.isEditNote,
                    'btn-secondary': !image.isEditNote,
                  })}
                  disabled={!image.isEditNote}
                  onClick={() => saveNote(idx)}>
                  <KTSVG className={'svg-icon-1'} path='/media/icons/duotune/general/gen037.svg' />
                </button> */}
                <button
                  className='btn btn-sm btn-icon btn-light-success btn-active-success me-5'
                  onClick={() => openImage(image.id)}>
                  <KTSVG className='svg-icon-1' path='/media/icons/duotune/files/fil024.svg' />
                </button>
                <button
                  className='btn btn-sm btn-icon btn-light-danger btn-active-danger'
                  onClick={() => onRemove(image.id)}>
                  <KTSVG className='svg-icon-1' path='/media/icons/duotune/files/fil007.svg' />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {openLightBox && (
        <Lightbox
          medium={lightBoxImage}
          large={lightBoxImage}
          alt={lightBoxAlt}
          // @ts-ignore
          onClose={closeImage}
        />
      )}
    </Modal>,
    modalsRoot
  )
}

export default PileExecutionAttachmentView
